import MapGeoidGlobe from './MapGeoidGlobe';

/**
 * The "MapGeoid" wordmark — "Map" plus "Ge" plus the globe mark standing in
 * for the "o" plus "id". Plain Tailwind, not MUI: App.tsx's own "powered by
 * MapGeoid" footer renders the same lockup with MUI's `Typography`/`Box`,
 * but this is for plain-React surfaces (currently just the login page).
 *
 * FIXED BRAND ELEMENT, same as `BlueViewMark`: not sourced from editable
 * settings, not restyled or removed through any role's Settings.
 */
export default function MapGeoidWordmark({
  size = 22,
  /** Colour of the "Map"/"id" text — set via inline style, not a class, so
   *  it stays correct even on a chip deliberately kept white/light inside a
   *  dark-themed ancestor (glass.css's `[data-theme='dark'] .text-[...]`
   *  class-based remap would otherwise overwrite a className-based colour
   *  here, same reasoning as its own documented `bv-keep-light` escape
   *  hatch — this sidesteps the whole mechanism rather than fighting it). */
  mapColor = '#0F2942',
  className = '',
}: {
  /** Height of the lockup in px; the globe and text both scale from it. */
  size?: number;
  mapColor?: string;
  className?: string;
}) {
  const fontSize = size * 1.05;
  return (
    <span
      className={`inline-flex items-center font-extrabold leading-none tracking-tight ${className}`}
      style={{ fontSize }}
    >
      <span style={{ color: mapColor }}>Map</span>
      <span style={{ color: '#4A90E2' }}>Ge</span>
      <span className="mx-px inline-flex items-center">
        <MapGeoidGlobe size={size} />
      </span>
      <span style={{ color: '#4A90E2' }}>id</span>
    </span>
  );
}
